import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieAttachmentType implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(private fId: string, private fCode: string) {
    [fId, fCode].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get code(): string {
    return this.fCode;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
